<template>
    <div class="page">
        <van-pull-refresh style="min-height: 100vh" v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
            <van-list ref="winPrize" v-if="winPrizeList.length > 0" v-model:loading="loading" :immediate-check="false"
                :finished="finished" finished-text="已到底~" @load="onLoad" :offset="500" class="item-box">
                <van-cell v-for="(item, index) in winPrizeList" :key="index" class="item-van" @click="goDetail()">
                    <div class="item-list">
                        <el-image :src="item.url" fit="cover" class="list-img">
                        </el-image>
                        <div class="list-title">
                            <div class="list-name">{{ item.id }}</div>
                            <div class="list-btn">
                                <div class="studyBtn">中奖时间：2023-10.26 12:00</div>
                            </div>
                        </div>
                    </div>
                    <div class="item-flex item-bottom">
                        <div class="item-flex">
                            <div style="color:#999999 ;margin-right: 10px;">兑奖码</div>
                            <div>36955454212</div>
                        </div>
                        <div class="item-status1 item-sty">
                            已发货
                        </div>
                        <div class="item-status2 item-sty">
                            未领取
                        </div>
                        <!-- <div class="item-status3 item-sty">
                            已失效
                        </div>
                        <div class="item-status4 item-sty">
                            待发货
                        </div>
                        <div class="item-status4 item-sty">
                            已领取
                        </div> -->
                    </div>


                </van-cell>
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import { getDetail,myWinner } from '@/api/lotteryInteractive'

export default {
    data() {
        return {
            isLoading: false, //下拉刷新
            winPrizeList: [{}],
            formData: {
                pageNum: 1,
            },
            loading: false,
            finished: false,
        }
    },
    mounted() {
      this.getMyWinner();
    },
    methods: {
        getMyWinner(){
          myWinner({webLotteryId:this.$route.query.id}).then(({data}) => {
            console.log(data)
            if(data.code==200){
              this.winPrizeList=data.data.list
            }
          })
        },
        //详情
        goDetail () {
            window.location.href = '/myPrizeDetail';
        },
        //下拉刷新
        onRefresh() {
            this.isLoading = true;
            this.formData.pageNum = 1;
            this.winPrizeList = []


            setTimeout(() => {
                this.isLoading = false;
            }, 1000);
        },
    }
}
</script>
<style scoped>
.page {
    padding: 12px;
    background-color: #F3F3F3;
}


.item-van {
    border-bottom: #fff;
}

.item-list {
    display: flex;
    padding: 16px;
    border-bottom: #F3F3F3 1px solid;
    margin-bottom: 20px;
}

.list-img {
    width: 125px;
    height: 84px;
    border-radius: 4px;
}

.list-title {
    display: flex;
    flex: 1;
    height: 84px;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 12px;
}

.list-name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
    /* 控制行数 */
}

.studyBtn {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
}

.item-flex {
    display: flex;
    align-self: center;
}

.item-bottom {
    justify-content: space-between;
    padding: 0 0 16px 12px;

}

.van-cell {
    padding: 0;
    margin-bottom: 12px;
    border-radius: 4px;
}

.van-cell::after {
    border-bottom: #fff;
}

.item-sty {
    width: 70px;
    height: 24px;
    border-radius: 40px 0 0 40px;
    line-height: 24px;
    text-align: center;
}

.item-status1 {
    background-color: #E8FAEF;
    color: #44BB57;
}

.item-status2 {
    background-color: #FAF3E8;
    color: #E3833D;
}

.item-status3 {
    background-color: #F4F4F4;
    color: #999999;
}

.item-status4 {
    background-color: #F4F4F4;
    color: #333333;
}
</style>